export const fieldMessage = (valid, message) => {
  if (valid === false) {
    return message;
  } else {
    return "";
  }
};